import {
  ActivityIndicator,
  Image,
  Platform,
  Pressable,
  View,
} from 'react-native';
import { Text } from '@/components/Text';
import { SquareGrid } from '@/components/SquareGrid';
import Entypo from '@expo/vector-icons/Entypo';
import { IS_WEB } from '@/utils/platform';

// hooks
import { useBildkartenExercise } from '@/hooks/useBildkartenExercise';
import { useNavigation } from '@react-navigation/native';

// styles
import { Icon } from '@/components/Icon';
import { PressableNeolexon } from '@/components/PressableNeolexon';
import { useEffect } from 'react';
import { colors } from 'react-native-elements';
import styles from './styles';

export function BildKartenExercise(props) {
  const isMobile = Platform.OS !== 'web';
  const { route, navigation } = props;
  const { goBack } = useNavigation();

  const { setId, exerciseClass, foundSet, isSelf } = route?.params ?? {};
  const { _images, generate, zielwort, showCorrectWord, isAuset } =
    useBildkartenExercise(setId, exerciseClass, foundSet);

  useEffect(() => {
    const tintColor = colors.white;
    navigation.setOptions({
      headerStyle: {
        ...(isMobile && styles.rotated180),
        height: 64,
        backgroundColor: colors.grey,
      },
      headerTitleStyle: {
        fontSize: 28,
        fontWeight: '600',
        color: tintColor,
      },
      headerUpsideDown: !IS_WEB && !isSelf ? true : false,
      headerTitle: () =>
        !isAuset ? (
          <PressableNeolexon
            onPress={showCorrectWord}
            style={styles.showWordButton}
          >
            <Entypo name="eye" size={18} color={'#3a3a3a'} />
            <Text style={styles.showWordText}>{zielwort}</Text>
          </PressableNeolexon>
        ) : null,
      headerLeft: () => (
        <Pressable onPress={goBack}>
          <Icon name="home" size={36} color={tintColor} />
        </Pressable>
      ),
      headerRight: () => (
        <Pressable
          onPress={generate}
          style={{ flexDirection: 'row', alignItems: 'center', gap: 2 }}
        >
          <Text
            style={{
              fontSize: 18,
              top: -1,
              color: tintColor,
              fontWeight: '600',
            }}
          >
            Weiter
          </Text>
          <Icon name="arrowRight" size={36} color={tintColor} />
        </Pressable>
      ),
    });
  }, [zielwort]);

  return (
    <View style={[styles.container, styles.flexFull]}>
      <View style={[styles.flexFull, styles.contentCenter]}>
        {_images.length === 0 ? (
          <ActivityIndicator />
        ) : (
          <View
            style={[
              styles.body,
              _images.length <= 2 ? styles.flexSemiFull : styles.flexFull,
            ]}
          >
            <SquareGrid
              items={_images.map((uri, i) => {
                return (
                  <PressableNeolexon style={styles.imageContainer} key={i}>
                    <Image
                      style={styles.flexFull}
                      resizeMode="contain"
                      source={{ uri }}
                    />
                  </PressableNeolexon>
                );
              })}
              itemMargin={3}
              columns={_images.length === 4 ? 2 : _images.length}
              rows={_images.length === 4 ? 2 : 1}
            />
          </View>
        )}
      </View>
    </View>
  );
}
